<template>
  <modal
    ref="addReport"
    :ok-disabled="loading"
    :ok-title="!$parent.id ? 'Pridať' : 'Upraviť'"
    :title="!$parent.id ? 'Pridať report' : 'Upraviť report'"
    cancel-title="Zrušiť"
    full-height
    name="add-consumer"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveReport"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" v-bar>
          <div>
            <b-form-group
              :label="
                'Obdobie ' +
                (energetic._measureType.const === 'MONTHLY' ? '(m/r)' : '(rok)')
              "
              label-cols-sm="5"
              label-for="period"
            >
              <single-date
                v-model="form.reportDate"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('period') }"
                :format="measureTypeFormat"
                data-vv-as="Obdobie"
                name="period"
              />
              <b-form-invalid-feedback>
                {{ errors.first('period') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Množstvo (MWh)"
              label-cols-sm="5"
              label-for="soPo"
            >
              <vue-autonumeric
                v-model="form.soPo"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('soPo') }"
                class="form-control"
                data-vv-as="Množstvo"
                name="soPo"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('soPo') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Množstvo (m3)"
              label-cols-sm="5"
              label-for="consumption"
            >
              <vue-autonumeric
                v-model="form.consumption"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('consumption') }"
                class="form-control"
                data-vv-as="Množstvo"
                name="consumption"
              />
              <b-form-invalid-feedback>
                {{ errors.first('consumption') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Max. odber DMM (m3)"
              label-cols-sm="5"
              label-for="quantity"
            >
              <vue-autonumeric
                v-model="form.quantity"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('quantity') }"
                class="form-control"
                data-vv-as="Max. odber DMM"
                name="quantity"
              />
              <b-form-invalid-feedback>
                {{ errors.first('quantity') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Prekročenie DMM (m3)"
              label-cols-sm="5"
              label-for="overDDK"
            >
              <vue-autonumeric
                v-model="form.overDDK"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('overDDK') }"
                class="form-control"
                data-vv-as="Prekročenie DMM"
                name="overDDK"
              />
              <b-form-invalid-feedback>
                {{ errors.first('overDDK') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Celková cena (€ bez dph)"
              label-cols-sm="5"
              label-for="totalPrice"
            >
              <vue-autonumeric
                v-model="form.totalPrice"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('totalPrice') }"
                class="form-control"
                data-vv-as="Celková cena"
                name="totalPrice"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('totalPrice') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Priem. jedn. cena (€ bez dph/MWh)"
              label-cols-sm="5"
              label-for="priceUnit"
            >
              <vue-autonumeric
                v-model="sumPriceUnit"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('priceUnit') }"
                class="form-control"
                data-vv-as="Priem. jedn. cena"
                disabled
                name="priceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('priceUnit') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import SingleDate from '@/components/inputs/SingleDate'
import Modal from '@/components/Modal'
import { mapState } from 'vuex'

export default {
  components: {
    SingleDate,
    Modal,
  },
  data() {
    return {
      loading: false,
      form: {},
      field: [],
      month: null,
      year: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
    measureTypeFormat() {
      if (this.energetic._measureType.const === 'MONTHLY') {
        return 'MM/YYYY'
      } else {
        return 'YYYY'
      }
    },
    sumPriceUnit: {
      get() {
        let total = this.form.totalPrice
        return total ? this.form.totalPrice / this.form.soPo : 0
      },
      set(val) {
        this.form.priceUnit = val
      },
    },
  },
  watch: {
    'form.reportDate': {
      immediate: true,
      handler(val) {
        if (this.measureTypeFormat === 'YYYY') {
          this.form.reportDate = `${this.$moment(val, 'YYYY').format('YYYY')}-12-31`
        }
      },
    },
  },
  methods: {
    fetchData() {
      this.form.energetics_id = parseInt(this.$route.params.energetics_id)
      if (this.$parent.id) {
        this.loading = true
        this.$api
          .get(`reports/${this.$parent.id}/consumer/get_form`)
          .then((res) => {
            this.form = res.data.data
            this.loading = false
          })
      }
    },
  },
}
</script>
